<template>
  <div class="key-takeaway-container">
    <div class="title">
      Key Takeaway
    </div>
    <span v-html="keyTakeaway" />
  </div>
</template>

<script>
export default {
  props: {
    keyTakeaway: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang='scss' scoped>
  .key-takeaway-container {
    background: #f2f4f7;
    padding: rem-calc(12);
    margin: rem-calc(20) 0;
    border-radius: 8px;
  }
  .title {
    color: #000000;
    font-size: rem-calc(20);
    font-weight: $bold;
    margin-bottom: rem-calc(8);
  }
</style>
